import LoadingState from '@/api/LoadingState';

const state = {
  user: undefined,
  loadingState: LoadingState.INITIAL,
}

export default state;
